<template>
  <div class="user-avator-dropdown">
    <Dropdown trigger="click" @on-click="handleClick">
      <Avatar style="color: #f56a00;background-color: #fde3cf">admin</Avatar>
      <Icon :size="18" type="md-arrow-dropdown"></Icon>
      <DropdownMenu slot="list">
        <DropdownItem name="logout">退出登录</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>

<script>
import './user.less'
import { mapActions } from 'vuex'
export default {
  name: 'User',
  props: {
    userAvator: {
      type: String,
      default: ''
    }
  },
  methods: {
    ...mapActions([
      'handleLogOut'
    ]),
    handleClick (name) {
      switch (name) {
        case 'logout':
          sessionStorage.removeItem('user')
          this.$router.push({
            name: 'login'
          })
        break
      }
    }
  }
}
</script>
